import { useMyContext } from "../context/RouterContext";

const base_url = process.env.REACT_APP_NEFRO_API_URL; // servidor en Node.js

const useFetchHook = () => {
    const { item: { email }, setItem } = useMyContext();
    
    // token guardado
    const getToken = () => localStorage.getItem('token') || '';
    // identificador de navegador
    const getDeviceId = () => localStorage.getItem('device_id') || '';
    
    const isTokenExpired = () => {
        const expiresAt = Number(localStorage.getItem('expires_at'));
        // el token expiró o expirará en menos de 1 minuto
        return Date.now() > expiresAt - 60 * 1000;
    };
    
    const renewToken = async (token) => {
        try {
            const device_id = getDeviceId();
            const res = await fetch(`${base_url}/sso/token-renew`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    device_id, email
                })
            });
        
            if (!res.ok) return token;
        
            const body = await res.json();
            const { status, access_token, expires_in } = body;
            if (status) {
                localStorage.setItem('token', access_token);
                localStorage.setItem('expires_at', Date.now() + expires_in * 1000);
                return access_token;
            }
            return token;
        } catch (err) {
            return token;
        };
    };
    
    const fetchRequest = (obj, method, url, token) => {
        const config = {
            method,
            headers: {
                'x-token': token,
                ...(method !== 'GET' && { 'Content-type': 'application/json' }),
            },
            ...(method !== 'GET' && { body: JSON.stringify(obj) }),
        };
        return fetch(url, config);
    };

    // petición restringida (sólo administradores)
    const protectedFetchReq = async (endpoint, obj, method = 'GET', setData) => {
        try {
            let token = getToken();
            const url = `${base_url}/${endpoint}`;
        
            if (isTokenExpired())
                token = await renewToken(token);
            
            const resp = await fetchRequest(obj, method, url, token);
            const body = await resp.json();
            const { status, msg } = body;
            if (!status && ['unavailable-token', 'invalid-token', 'token-expired'].includes(msg)) {
                setData(e => ({
                    ...e,
                    snackbar_status: {
                        ...e.snackbar_status,
                        open: true,
                        message: 'Expiró su sesión',
                    }
                }));
                localStorage.removeItem('token');
                setItem(e => ({ ...e, email: '', username: '', loadingSession: false }));
                return null;
            }
            return body;
        } catch (err) {
            return null;
        };
    };
    
    return { protectedFetchReq };
};

export default useFetchHook;
